export enum AuthPermission {
  ScheduleTour = 'ScheduleTour',
  SubmitApplication = 'SubmitApplication',
  AcceptApplication = 'AcceptApplication',
  BrowseApplication = 'BrowseApplication',
  CreateRentEstate = 'CreateRentEstate',
}
